import * as React from "react";
import {useEffect, useState} from "react";
import {formatXAxisPeriodToYearForPlanMarketValue, getAxisValueScale} from "../../utils/chartUtils";
import {HorizontalBarChart, IHorizontalBarChartProps} from "../common/HorizontalBarChart.component";
import {formatCurrency} from "../../utils/numberUtil";
import {hasConsultantLevelAccess} from "../../utils/sessionUtil";
import {StyledToggle} from "../common/material-ui-core/Toggle.component";
import planApi from "../../api/PlanApi";
import {requestPlanSettings} from "../root/rootActions";
import {useDispatch} from "react-redux";
import {AnyThunkDispatch} from "../../../commonTypes";

export const CLIENT_NET_CASH_FLOWS_TOGGLE_TEXT = "Show Net Cash Flows for Client Users";

interface IPlanCashFlowBarChartProps extends IHorizontalBarChartProps {
    clientPortfolioAccess: boolean;
    clientNetCashFlowsAccess: boolean;
}

export const PlanCashFlowBarChart: React.FunctionComponent<IPlanCashFlowBarChartProps> = (props) => {
    const dataScale = getAxisValueScale(props.data.map(it => it.value!));
    const [clientNetCashFlowsAccess, setClientNetCashFlowsAccess] = useState<boolean>(props.clientNetCashFlowsAccess);
    const dispatch: AnyThunkDispatch = useDispatch();

    useEffect(() => {
        setClientNetCashFlowsAccess(props.clientNetCashFlowsAccess);
    }, [props.clientNetCashFlowsAccess]);

    const chartValueFormatFunction = (value: number | string) => {
        if (typeof value === "string") {
            return value;
        }
        return `${formatCurrency(value, 0)}`;
    };

    const updateClientNetCashFlowsAccess = (updatedValue: boolean) => {
        setClientNetCashFlowsAccess(updatedValue);
        planApi.updatePlanClientNetCashFlowsEnabled(updatedValue)
            .then(() => dispatch(requestPlanSettings()));
    };

    const renderClientNetCashFlowsToggle = () => {
        if (!hasConsultantLevelAccess() || !props.clientPortfolioAccess) {
            return null;
        }

        return <span className="financial-reconciliation-tab__net-cash-flow-toggle"
                     data-testid="financial-reconciliation-tab__net-cash-flow-toggle">
            <StyledToggle
                toggleState={clientNetCashFlowsAccess}
                setToggle={updateClientNetCashFlowsAccess}
                label={CLIENT_NET_CASH_FLOWS_TOGGLE_TEXT}
                labelPlacement="start"/>
        </span>;
    };

    return <div className="plan-cash-flow-chart__container" data-testid="plan-cash-flow-chart__container">
        <div className="plan-cash-flow-chart__title-container">
            <h3>Net Cash Flows</h3>
            {renderClientNetCashFlowsToggle()}
        </div>
        <div className="plan-cash-flow-chart__sub-title">
            {`Total net cash flows in ${dataScale === 1000 ? "Thousands" : "Millions"}`}
        </div>
        <HorizontalBarChart
            data={props.data}
            tooltipLabel={"Net Cash Flow: "}
            valueFormatFunction={chartValueFormatFunction}
            xAxisFormater={formatXAxisPeriodToYearForPlanMarketValue}
            yAxisFormater={value => formatCurrency(value / dataScale, 0)}
        />
    </div>;
};